import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMxlinuxComponent } from './simple-icons-mxlinux.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMxlinuxComponent ],
    exports:      [ SimpleIconsMxlinuxComponent ],
    bootstrap:    []
})
export class SimpleIconsMxlinuxModule {}
